/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientCard/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function PatientCard({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Patient/Content/SearchResult/Content/PatientCard"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let personValueData1 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.getName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let personValueData2 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.maybeGetEmail,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let personValueData3 = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromHelpers.maybeGetPhone,
})
  return (<React.Fragment
>
<button
  data-testid="PatientCard.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mb-1-Z2tNy7O': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PatientCard.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-Z2tNy7O': dtColorsNeutral200,'--btlr-3-Z2tNy7O': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--btrr-4-Z2tNy7O': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bblr-5-Z2tNy7O': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bbrr-6-Z2tNy7O': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--mr-7-Z2tNy7O': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--h-8-Z2tNy7O': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--w-9-Z2tNy7O': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 size="medium"
 data="person"
 format="/Data/format.js initials"
 text={personValueData}
/>
</div>
<div
  data-testid="PatientCard.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 backgroundColor={dtColorsNeutral900}
 data="person"
 format="helpers.js getName"
 text={personValueData1}
/>
<div
  data-testid="PatientCard.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-10-Z2tNy7O': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="person"
 format="helpers.js maybeGetEmail"
 text={personValueData2}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="person"
 format="helpers.js maybeGetPhone"
 text={personValueData3}
/>
</div>
</div>
</button>
{children}
</React.Fragment>)
}